import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setCloseInvoiceListModal } from "../../redux/features/invoice/invoiceSlice";
import { FetchInvoiceDetailList } from "../../redux/features/invoice/invoiceAction";
import { CommonTable } from "../../modules/common/table/Table";
import { invoiceDetailListColumns } from "../../modules/common/table/columns/_invoiceDetailListColumns";
import SharedPagination from "../../modules/common/sharedPagination";


const InvoiceDetailModal = () => {
    const dispatch: any = useDispatch();
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    const limit = 10;

    const states = useSelector((state: any) => state.invoiceSlice);
    const invoiceDetailList = states?.invoiceDetails || [];
    const totalRecord = states?.detailsTotalRecord || 0;
    const totalPages = Math.ceil(totalRecord / limit);

    const { openInvoiceListModal, modalListData } = useSelector(
        (state: any) => state.invoiceSlice
    );

    useEffect(() => {
        if (openInvoiceListModal && modalListData?.invoice_number) {
            const fetchInvoice = async () => {
                setLoading(true);
                try {
                    await dispatch(FetchInvoiceDetailList({
                        invoice_number: modalListData.invoice_number,
                        page: currentPage,
                        limit,
                    }));
                } catch (error) {
                    console.error("Failed to fetch invoice detail:", error);
                } finally {
                    setLoading(false);
                }
            };

            fetchInvoice();
        }
    }, [openInvoiceListModal, modalListData, currentPage]);

    const handleClose = () => {
        dispatch(setCloseInvoiceListModal());
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <Modal className="detailModal" show={openInvoiceListModal} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Detail of the Invoice</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='orderListTable'>
                    {loading ? (
                        <p className="loading-text">Caricamento fattura...</p>
                    ) : invoiceDetailList?.length > 0 ? (
                        <CommonTable data={invoiceDetailList} columns={invoiceDetailListColumns} />
                    ) : (
                        <p className="no-orders">No invoice available.</p>
                    )}
                </div>
                {totalRecord > 10 && <SharedPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />}
            </Modal.Body>
        </Modal>
    );
};

export default InvoiceDetailModal;

